import { XeroAccountMappingDTO } from "@gymflow/types";
import { useFormik } from "formik";

import { XeroIntegrationFormValues } from "../types";

export const populateFormFromAccountMapping = (
  formik: ReturnType<typeof useFormik<XeroIntegrationFormValues>>,
  data: XeroAccountMappingDTO,
) => {
  formik.setFieldValue("clearing", data.clearing?.name ?? "");

  const fields: (keyof Omit<XeroIntegrationFormValues, "clearing">)[] = [
    "payout",
    "charge",
    "refund",
    "fee",
    "adjustment",
    "other",
  ];

  for (const field of fields) {
    const value = data[field];
    if (value) {
      formik.setFieldValue(field, {
        id: value.id,
        label: value.name,
        value: value.id,
      });
    }
  }
};
